export function replaceConsentText(input: string, label: string | undefined): string {
  if (label) {
    return input.replace(
      /<a(\s\w+?[^=]*?="[^"]*?")*?\s+?class="(\S+?\s)*?ucShow_(\s\S+?)*?".*?>(.*?)<\/a>/,
      `<a href="#" class="_openUsercentricsLayer">${label}</a>`,
    );
  }
  return '';
}
